module.exports = __webpack_public_path__ + "static/media/1018951.467bd1d3.jpg";